import { ChevronRight } from "lucide-react";
import type { ComponentType, ReactNode } from "react";
import { cn } from "@/lib/utils";

export type Crumb = {
  label: ReactNode;
  href?: string;
  onSelect?: () => void;
};

type LinkProps = { href: string; className: string; children: ReactNode };
const Anchor = ({ href, className, children }: LinkProps) => <a href={href} className={className}>{children}</a>;

/** `link` draws a crumb that navigates, such as a router's link; a plain anchor by default. */
export function Breadcrumb({ items, className, link: Link = Anchor }: { items: Crumb[]; className?: string; link?: ComponentType<LinkProps> }) {
  return (
    <nav aria-label="Breadcrumb" data-slot="breadcrumb" className={className}>
      <ol className="flex flex-wrap items-center gap-1 text-sm">
        {items.map((item, index) => {
          const last = index === items.length - 1;
          const link = "inline-flex items-center gap-1 rounded-md px-1 py-0.5 text-secondary no-underline can-hover:hover:text-foreground outline-none focus-visible:outline-2 focus-visible:outline-[var(--focus-outline)]";
          return (
            <li key={index} className="flex items-center gap-1">
              {last ? (
                <span aria-current="page" className="px-1 py-0.5 text-foreground">
                  {item.label}
                </span>
              ) : item.href ? (
                <Link href={item.href} className={link}>
                  {item.label}
                </Link>
              ) : (
                <button type="button" onClick={item.onSelect} className={cn(link)}>
                  {item.label}
                </button>
              )}
              {last ? null : <ChevronRight aria-hidden className="size-3.5 text-muted" strokeWidth={1.75} />}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
